<template>
    <div class="o-wrapper o-wrapper--center">
      <div class="u-flex u-flex--align-items-baseline u-flex--content-between" :class="{ 'line' : this.checkedItems[0]}">
        <div v-if="this.checkedItems[0]">
          <p class="u-inline-block u-font-weight-medium u-text-uppercase u-margin-right">{{ $t('product_overview.filters.active_shop') }}</p>
          <span v-if="this.checkedItems[0]" class="brand-selected">{{this.checkedItems[0].DisplayValue}}</span>
        </div>
        <strong v-if="!this.checkedItems[0]" class="u-font-weight-bold u-flex" style="font-size: 26px; margin: auto">{{ $t('product_overview.no_shop') }}</strong>

        <button v-if="this.checkedItems[0]" type="button" @click="toggleState" class="c-button--brands c-icon-label">
            <span class="c-icon-label__content">{{ $t('product_overview.filters.change_shop') }}</span>
            <svgicon style="transition-property: transform; transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1); transition-duration: 150ms;" :class="[ active ? 'svg-up' : 'svg-down' ]" name="arrow-right" height=".7em"></svgicon>
        </button>
      </div>
      <div :class="{'u-hidden': !active, 'u-flex--content-center' : !this.checkedItems[0] }" class="c-nav--horizontal brand-list" >
        <v-filter-brands-element
          v-for="item in filteredItems"
          :key="item[itemValue]"
          :value="item"
          @item-selected="itemSelected">
          {{item[itemName]}}
        </v-filter-brands-element>
      </div>
    </div>
</template>

<script>
    import VFilterBrandsElement from '@/components/form/filters/FilterBrandsElement'
    import VInput from '@/components/form/Input'

    export default {
        props: {
            items: {type: Array, default: () => []},
            filterName: String,
            itemName: {type: String, default: 'name'},
            itemValue: {type: String, default: 'value'},
            selectedFilters: {},
        },
        data() {
            return {
              active: false,
              open: false,
              search: ''
            }
        },
        components: {
            VFilterBrandsElement,
            VInput,
        },
        computed: {
            checkedItems() {
                let output = [];
                this.items.map(item => {
                    if (item.IsSelected) {
                        output.push(item);
                    }
                });

                let x = true;

                for (let i = 0; i < this.items.length; i++) {
                  if (this.items[i]['IsSelected']) {
                    x = false;
                  }
                }

                this.active = x;
                return output;
            },
            filteredItems() {
                if (typeof this.items !== "undefined") {

                    return this.items.filter(item => {
                        if(item[this.itemName] != null){
                            return item[this.itemName].toLowerCase().indexOf(this.search.toLowerCase()) > -1
                        }
                    })
                }
            },
        },
        methods: {
          toggleState() {
            this.active = !this.active;
          },
          itemSelected(value) {
            this.items.forEach(item => {
              if(item.Value !== value) {
                item.IsSelected = false;
              }
            });

            Object.keys(this.selectedFilters).forEach(k => this.selectedFilters[k] = null);
            this.$emit('input', this.checkedItems);
            this.$emit('change');
            sessionStorage.setItem('customerFilters', window.location.search);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .brand-list {
      align-content: space-around;
      gap: em($global-spacing-unit-small);
      padding-top: em($global-spacing-unit-small);
      margin-top: em($global-spacing-unit-small);
    }

    .brand {
      padding: em($global-spacing-unit-small);
      outline: solid 1px $color-neutral;
      text-decoration: none;
      color: $color-base;
      font-weight: $medium;
    }

    .brand:hover {
      outline: solid 2px $color-alpha;
      color: $color-alpha;
      cursor: pointer;
    }

    .brand-selected {
      padding: em($global-spacing-unit-small);
      outline: solid 2px $color-alpha;
      font-weight: $medium;
      color: $color-alpha;
    }

    .c-button--brands {
      background: none;
      border: none;
      color: $color-base;
      box-shadow:none !important;
      font-weight: $semi-bold !important;
      text-decoration: underline;
      font: inherit;
      padding: em($global-spacing-unit-small) em($global-spacing-unit);
      line-height: 1;
    }

    .line {
      border-bottom: 1px solid rgba($color-base, .2);
    }
</style>



// WEBPACK FOOTER //
// src/components/form/filters/FilterBrands.vue